import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getEmployeeLeave = async ({
  companyCode,
  employeeCode,
  locationCode,
  isAllCompanies = false,
  userId = 0,
  selectedCompanyCode = "",
}) => {
  if (companyCode && employeeCode && locationCode) {
    let queryString = `?IsAllCompanies=${isAllCompanies}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&Employeecode=${employeeCode}&LocationCode=${locationCode}`;
    if (isAllCompanies) {
      queryString += `&UserId=${userId}`;
    }

    const data = await http_payroll.get(
      `${Api_EndPoints.GetEmployeeLeaveData}${queryString}`,
    );
    return data;
  }

  return [];
};

export const useGetEmployeeLeaveQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetEmployeeLeaveData],
    queryFn: () => getEmployeeLeave(input),
    refetchOnWindowFocus: false,
    // staleTime: 0,
    // enabled: false,
  });
};

const getAllEmployeeLeave = async ({
  companyCode,
  locationCode,
  userId = 0,
  selectedCompanyCode = "",
  isAllCompanies = false,
}) => {
  if (locationCode && companyCode) {
    let queryString = `?isAllCompanies=${isAllCompanies}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;
    if (isAllCompanies) {
      queryString += `&UserId=${userId}`;
    }
    const data = await http_payroll.get(
      `${Api_EndPoints.GetEmployeeLeaveData}${queryString}`,
    );
    return data;
  }
  return [];
};

export const useGetAllEmployeeLeaveQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.getAllEmployeeLeave, input],
    queryFn: () => getAllEmployeeLeave(input),
    refetchOnWindowFocus: false,
  });
};
